/** Stamped by the npm `version` lifecycle. Do not edit by hand. */
export const version = '0.1.0';
